import React from "react";
import { Link } from "react-router-dom";
import { mainABoutData } from "../../utils/NavData";

const PRIMARY = "#000c66";
const GOLD = "#ffc000";

const STYLES = `
  .mac-card { overflow: hidden; }
  .mac-img-wrap { overflow: hidden; position: relative; }
  .mac-img-wrap img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: transform 0.55s cubic-bezier(0.25,0.46,0.45,0.94);
  }
  .mac-ring {
    padding: 5px;
    border: 2px solid ${GOLD};
    display: block;
  }
  .mac-card:hover .mac-img-wrap img { transform: scale(1.045); }
  .mac-img-wrap::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,12,102,0.18) 0%, transparent 50%);
    pointer-events: none;
  }
  .mac-arrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: Abel, sans-serif;
    font-size: 11px;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: ${PRIMARY};
    text-decoration: none;
    transition: gap 0.2s;
  }
  .mac-arrow svg { transition: transform 0.2s; }
  .mac-arrow:hover { color: ${GOLD}; }
  .mac-arrow:hover svg { transform: translateX(4px); }
  .mac-divider {
    width: 32px;
    height: 2px;
    background: ${GOLD};
    margin: 14px 0 12px;
    transition: width 0.35s;
  }
  .mac-card:hover .mac-divider { width: 52px; }
`;

const scrollTop = () =>
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

export const MainAboutCard = () => {
  return (
    <>
      <style>{STYLES}</style>

      <section style={{ background: "#fff", padding: "64px 16px 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {/* Section eyebrow */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 48,
            }}
          >
            <div style={{ width: 32, height: 2, background: GOLD }} />
            <span
              style={{
                fontFamily: "Abel, sans-serif",
                fontSize: 10,
                letterSpacing: "0.28em",
                textTransform: "uppercase",
                color: PRIMARY,
              }}
            >
              Our Story
            </span>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "0 32px",
            }}
            className="mac-grid"
          >
            {mainABoutData.map((item, i) => (
              <div key={item.path} className="mac-card">
                {/* Image */}
                <Link to={item.path} onClick={scrollTop} style={{ display: "block" }}>
                  <div className="mac-ring">
                    <div className="mac-img-wrap">
                      <img src={item.image} alt={item.title} />
                    </div>
                  </div>
                </Link>

                {/* Content */}
                <div style={{ paddingTop: 22 }}>
                  {/* Index */}
                  <span
                    style={{
                      fontFamily: "Abel, sans-serif",
                      fontSize: 10,
                      letterSpacing: "0.24em",
                      color: GOLD,
                    }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>

                  {/* Gold divider */}
                  <div className="mac-divider" />

                  {/* Title */}
                  <Link
                    to={item.path}
                    onClick={scrollTop}
                    style={{ textDecoration: "none" }}
                  >
                    <h3
                      style={{
                        fontFamily: "Aref Ruqaa, serif",
                        fontWeight: 700,
                        fontSize: "clamp(1.1rem, 1.8vw, 1.35rem)",
                        color: PRIMARY,
                        margin: "0 0 12px",
                        lineHeight: 1.2,
                      }}
                    >
                      {item.title}
                    </h3>
                  </Link>

                  {/* Text */}
                  <p
                    style={{
                      fontFamily: "Abel, sans-serif",
                      fontSize: 14,
                      color: "rgba(0,12,102,0.6)",
                      lineHeight: 1.7,
                      margin: "0 0 20px",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item.text}
                  </p>

                  {/* Arrow link */}
                  <Link
                    to={item.path}
                    onClick={scrollTop}
                    className="mac-arrow"
                  >
                    Explore
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Responsive */}
      <style>{`
        @media (max-width: 900px) {
          .mac-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 40px 28px !important; }
        }
        @media (max-width: 520px) {
          .mac-grid { grid-template-columns: 1fr !important; gap: 40px 0 !important; }
        }
      `}</style>
    </>
  );
};
